

















import Vue from "vue";
import { ENTER_KEY } from "@tt-app/constants";

interface Methods {
  nextQuestion: () => void;
  sendUserSkip: () => void;
  sendUserResponse: () => void;
  enterPressed: (event: KeyboardEvent) => void;
}

interface Computed {
  answerWithoutWhitespace: boolean;
  nextButtonText: string;
  skipButtonText: string;
  sendButtonText: string;
  submitDisabled: boolean;
}

interface Props {
  answer: string;
  disabled: boolean;
  finalQuestion: boolean;
  questionAnswered: boolean;
}

export default Vue.extend<any, Methods, Computed, Props>({
  name: "TranslationButtons",

  props: {
    answer: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    finalQuestion: { type: Boolean, default: false },
    questionAnswered: { type: Boolean, default: false }
  },

  methods: {
    nextQuestion() {
      this.$emit("nextQuestion");
    },

    sendUserSkip() {
      this.$emit("userSkip");
    },

    sendUserResponse() {
      this.$emit("userResponse");
    },

    enterPressed(event) {
      if (event.keyCode === ENTER_KEY) {
        if (!this.questionAnswered && !this.submitDisabled) {
          this.sendUserResponse();
        }
      }
    }
  },

  computed: {
    answerWithoutWhitespace() {
      return this.answer.trim();
    },

    nextButtonText() {
      return this.finalQuestion ? "drill.nav.continue-last" : "drill.nav.continue";
    },

    skipButtonText() {
      return this.finalQuestion ? "drill.nav.skip-last" : "drill.nav.skip";
    },

    sendButtonText() {
      return "exercise.action.send";
    },

    submitDisabled() {
      return !this.answerWithoutWhitespace || this.disabled;
    }
  },
  created() {
    window.addEventListener("keyup", this.enterPressed);
  },
  destroyed() {
    window.removeEventListener("keyup", this.enterPressed);
  }
});
